export class RegistrationInstitution {

  public id: string;
  public registrationId: string;
  public institutionId: string;
  public name: string;
}
